export default __webpack_public_path__ + "static/media/coin-fill.2b0a81d5.svg";